
var app = angular.module('directives.paymentGroups', []);

require('./directives/paymentGroups.js');
require('./stylesheets/paymentGroups.scss');
require('./templates/index.html');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/paymentGroups/index.js
 ** module id = 206
 ** module chunks = 1
 **/